import { MONTHLY } from 'self-service-api/constants/Terms';
import { View } from 'foundations-components/components/View';
import { planBuilderQuantityUpdated } from '../../../actions/PlanBuilderActions';
import { CREATE_A_BUNDLE } from '../../../constants/tracking/TrackingSources';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { planBuilderIsLoadingSelector, planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import SeatsPickerStepper from '../../common/quantityPacks/SeatsPickerStepper';
import { Divider } from '../SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuantityPickerSeats = ({
  additionalUnitSkuId
}) => {
  const dispatch = useAppDispatch();
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const planBuilderIsLoadingData = useAppSelector(planBuilderIsLoadingSelector);
  const foundConfig = productConfigurations.find(({
    skuId
  }) => skuId === additionalUnitSkuId);
  const selectedAdditionalUnitsQuantity = foundConfig ? foundConfig.quantity : 0;
  const onChange = quantity => {
    dispatch(planBuilderQuantityUpdated({
      skuId: additionalUnitSkuId,
      quantity
    }));
  };

  // For now, we're opting to NOT show discounted prices in our units pickers,
  // so we're setting the queryParamTerm to MONTHLY
  const unitsPickerDisplayTerm = MONTHLY;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlock: "700",
      children: /*#__PURE__*/_jsx(Divider, {})
    }), /*#__PURE__*/_jsx(SeatsPickerStepper, {
      additionalUnitSkuId: additionalUnitSkuId,
      additionalUnitQuantity: selectedAdditionalUnitsQuantity,
      onChange: onChange,
      productConfigurations: productConfigurations,
      queryParamTerm: unitsPickerDisplayTerm,
      trackingSource: CREATE_A_BUNDLE,
      disableSteppers: planBuilderIsLoadingData
    })]
  });
};
export default QuantityPickerSeats;